import DetailsRender from './DetailsRender';

export const columnMeta = [
  {
    id: 'nickName',
    label: 'Nickname',
    xs: 2,
  },
  {
    id: 'cardType',
    label: 'Card Type',
    xs: 2,
  },
  {
    id: 'cardNumber',
    label: 'Card Number',
    xs: 3,
  },
  {
    id: 'cardStatus',
    label: 'Status',
    xs: 2,
  },
  {
    id: 'expirationDate',
    label: 'Expiration',
    xs: 3,
  },
];

export const defaultOrderBy = 'createdAt';

export const detailsRender = (item) => <DetailsRender item={item} />;
